import { EditorState, Modifier, SelectionState } from 'draft-js';
import { createRef, PureComponent } from 'react';
import { v4 as uuidV4 } from 'uuid';

import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

export default class FITBEditor extends PureComponent {
  state = { text: '' };
  textInputEl = createRef();

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      const { editorState, onUpdateEditorState } = this.props;
      let selection = editorState.getSelection();
      const startKey = selection.getStartKey();
      const contentState = editorState.getCurrentContent();
      const blockText = contentState.getBlockForKey(startKey).getText();
      // If multiple blocks are selected, change selection to only the initial block
      if (startKey !== selection.getEndKey()) {
        selection = new SelectionState({
          anchorKey: selection.getStartKey(),
          anchorOffset: selection.getStartOffset(),
          focusKey: selection.getStartKey(),
          focusOffset: blockText.length,
        });
        onUpdateEditorState(EditorState.acceptSelection(editorState, selection));
      }
      const text = blockText.substring(selection.getStartOffset(), selection.getEndOffset());
      this.setState({ text }, () => this.textInputEl.current.focus());
    }
  }

  confirm = () => {
    const { editorState, onClose, onUpdateEditorState } = this.props;
    const { text } = this.state;
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity('FILL_IN_THE_BLANK', 'IMMUTIBLE', {
      id: uuidV4(),
      value: text,
    });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const selection = editorState.getSelection();
    const contentStateWithLinkText = Modifier.replaceText(contentStateWithEntity, selection, text, null, entityKey);

    const newSelOffset = selection.getStartOffset() + (text || '').length;

    const editorStateWithLinkText = EditorState.set(editorState, {
      currentContent: contentStateWithLinkText,
      selection: selection.merge({ focusOffset: newSelOffset, anchorOffset: newSelOffset, hasFocus: true }),
      forceSelection: true,
    });

    onUpdateEditorState(editorStateWithLinkText);
    onClose();
  };

  handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.confirm();
    }
  };

  render() {
    const { anchorEl, onClose, onExited, show } = this.props;
    const { text } = this.state;
    return (
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        css={rootCss}
        disableRestoreFocus
        onClose={onClose}
        open={show}
        slotProps={{ paper: { className: 'FBE-popover' }, transition: { onExited } }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Typography variant="h6">Insert Input</Typography>
        <TextField
          fullWidth
          inputRef={this.textInputEl}
          margin="normal"
          onChange={e => this.setState({ text: e.target.value })}
          onKeyDown={this.handleKeyDown}
          placeholder="Answer"
          value={text}
          variant="standard"
        />
        <Button onClick={this.confirm} variant="text">
          Done
        </Button>
      </Popover>
    );
  }
}

const rootCss = ({ spacing, zIndex }) => ({
  zIndex: `${zIndex.modal + 2} !important`,
  '.FBE-popover': {
    minWidth: 200,
    padding: spacing(1, 2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});
